import { Box, IconButton, InputAdornment, Typography } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import TkButton from "../../components/atoms/TkButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import { headTitleList } from "./parts";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import TkCorporateSearchModal from "../../components/molecules/TkCorporateSearchModal";
import SCRW150002 from "../SCRW150002";
import { getNewBodyList } from "./hooks/useHooks";
import { httpAPI_CHA001, httpAPI_CHA002, httpAPI_CON001 } from "./api/request";
import TkDatePicker from "../../components/atoms/TkDatePicker";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { Prefectures } from "../../assets/data/Constants";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import TkLabelText from "../../components/atoms/TkLabelText";
import CheckBoxGroupForFakeTableLine from "../../components/atoms/TkFakeTableLine/components/checkBoxGroupForFakeTableLine";
import { ClearIcon } from "@mui/x-date-pickers";
import dayjs from "dayjs";

/**
 * SCRW150001_共済契約者との連絡掲示板
 * @return SCRW150001_共済契約者との連絡掲示板
 */
const SCRW150001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [bodyList, setBodyList] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [getContractorNo, setGetContractorNo] = useState("");
  const [searchListData, setSearchListData] = useState<any[]>([]);
  const [errorMsg, setErrorMsg] = useState<any>({});
  const [isSearch, setIsSearch] = useState(false);
  const [contractorData, setContractorData] = useState<any>();
  const startDay = dayjs().subtract(3, "month").format("YYYY/MM/DD");
  const finishDay = dayjs().format("YYYY/MM/DD");
  const [fieldValue, setFieldValue] = useState<any>({
    startDay,
    finishDay,
    managerUserName: state.authInfo?.name,
  });

  const handleSearch = async (userId?: any) => {
    if (Object.values(errorMsg).some((item) => item)) {
      return;
    }

    // スレッド一覧参照API 呼び出し
    try {
      const res = await httpAPI_CHA001({
        userId,
        ...fieldValue,
        contractorNo: contractorData?.contractorNo,
        contractorName: contractorData?.contractorName,
      });

      if (res.resultCd === "I0000") {
        const threadList = res.threadList;
        const newBodyList = getNewBodyList(threadList, nameClick, finishClick);
        setBodyList(newBodyList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleSearch(state.authInfo?.userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nameClick = (contractorNo: string) => {
    setGetContractorNo(contractorNo);
    chatOpen();
  };

  const serchDialogOpen = () => {
    setSearchListData([]);
    setIsSearch(true);
    setOpen(true);
  };

  const finishClick = async (threadId: number) => {
    // スレッド更新API 呼び出し
    try {
      const res = await httpAPI_CHA002({
        finishFlg: "1",
        threadId: threadId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        handleSearch();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const newThreadCreate = () => {
    setSearchListData([]);
    setIsSearch(false);
    setOpen(true);
  };

  const handleSave = (e: any) => {
    setOpen(false);
    if (isSearch) {
      setContractorData(e);
    } else {
      setGetContractorNo(e.contractorNo);
      chatOpen();
    }
  };

  const handleChangeSearchData = async (e: any) => {
    // 契約者一覧参照API 呼び出し
    try {
      const res = await httpAPI_CON001({
        contractorNo: e?.contractorNo,
        corpName: e?.corpName,
        prefectureCd: e?.prefectureCd,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setSearchListData(res.contractorList!);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setSearchListData([]);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const dialogClose = () => {
    setOpenDialog(false);
    handleSearch();
  };

  const chatOpen = () => {
    setOpenDialog(true);
  };

  const handleChange = (field: string, value: any) => {
    setFieldValue((prev: any) => {
      const newValue = {
        ...prev,
        [field]: value,
      };
      if (!value) delete newValue[field];
      return newValue;
    });

    if (field === "managerUserName") {
      if (!value.match(/^([^ -~｡-ﾟ])*$/)) {
        setErrorMsg((prev: any) => ({
          ...prev,
          managerUserName: TkPropertyMessageGet("TKMSG_SCR0061E"),
        }));
      } else {
        setErrorMsg((prev: any) => ({
          ...prev,
          managerUserName: "",
        }));
      }
    }
  };

  const handleDateError = (field: string) => (error: any) => {
    setErrorMsg((prev: any) => ({
      ...prev,
      [field]: error,
    }));
  };

  const handleClear = () => {
    setContractorData(null);
    setSearchListData([]);
  };

  return (
    <Box data-testid="SCRW150001PageForTest" className="tkSCRW150001">
      <Box className="tkTitleMessage">
        <Typography>{"検索項目"}</Typography>
      </Box>
      <Box className="tkSerchBox">
        <Box className="tkMidBox">
          <Box className="tkItem ">
            <Typography>{"開始日:"}</Typography>
            <TkDatePicker
              minDate={new Date("1900/1/1")}
              maxDate={new Date("2099/12/31")}
              onChange={(e: any) => handleChange("startDay", e.target.value)}
              wantToSetValue={startDay}
              onGetErrorFlg={handleDateError("startDay")}
            />
          </Box>
          <Box className="tkItem">
            <Typography>{"終了日:"}</Typography>
            <TkDatePicker
              minDate={new Date("1900/1/1")}
              maxDate={new Date("2099/12/31")}
              onChange={(e: any) => handleChange("finishDay", e.target.value)}
              wantToSetValue={finishDay}
              onGetErrorFlg={handleDateError("finishDay")}
            />
          </Box>
          <TkSelectForm
            selectPropsList={TkGetCodeList(Prefectures)}
            label={"都道府県"}
            onGetValue={(e: any) => handleChange("prefecture", e)}
          />
        </Box>
        <Box className="tkMidBox">
          <Box className="tkItem corpSearch">
            <TkLabelText
              wantToSetValue={
                contractorData
                  ? (contractorData.contractorNo ?? "") +
                    ":" +
                    (contractorData.corpName ?? "")
                  : ""
              }
              variant="standard"
              disabled
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClear}
                      edge="end"
                      sx={{ padding: 0.5, marginRight: 0.2 }}
                    >
                      <ClearIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TkButton onClick={serchDialogOpen}>{"法人検索"}</TkButton>
          </Box>
          <TkLabelText
            error={!!errorMsg.managerUserName}
            helperText={errorMsg.managerUserName}
            label={"担当者"}
            variant="standard"
            wantToSetValue={state.authInfo?.name}
            onChange={(e: any) =>
              handleChange("managerUserName", e.target.value)
            }
          />
          <CheckBoxGroupForFakeTableLine
            checkBoxList={[{ label: "終了したものを表示する" }]}
            onGetValue={(e: any) =>
              handleChange("finishFlg", e.length ? "1" : "")
            }
          />
          <TkButton onClick={handleSearch}>{"検索"}</TkButton>
        </Box>
      </Box>
      <Box className="tkNewThread">
        <TkButton onClick={newThreadCreate}>{"新規投稿"}</TkButton>
      </Box>
      <TkDataTable
        headList={headTitleList}
        bodyList={bodyList}
        defaultRowsPerPage={10}
        pagin
      />
      <TkCorporateSearchModal
        open={open}
        onSave={handleSave}
        onChangeSearchData={handleChangeSearchData}
        onClose={handleClose}
        listData={searchListData}
      />
      <SCRW150002
        open={openDialog}
        contractorNo={getContractorNo}
        onClose={dialogClose}
      />
    </Box>
  );
};

export default SCRW150001;
